module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_library.js
// module id = 33
// module chunks = 0